import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const INITIAL_STATE = {
  saveSkipStatus: false,
  settingStatus: false,
};

const companySkipSaveSlice = createSlice({
  name: "companySkipSave",
  initialState: INITIAL_STATE,
  reducers: {
    skipSave: (state) => {
      console.log(INITIAL_STATE, "INITIAL_STATE");
      state.saveSkipStatus = true;
    },
    skipNotSave: (state) => {
      console.log(INITIAL_STATE, "INITIAL_STATE");
      state.saveSkipStatus = false;
    },
    settingsOpen: (state) => {
      state.settingStatus = true;
    },
    settingsClose: (state) => {
      state.settingStatus = false;
    },
    skipReset: (state) => {
      return (state = INITIAL_STATE);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE); // THIS LINE
  },
});

export const { skipSave, skipNotSave, settingsOpen, settingsClose, skipReset } =
  companySkipSaveSlice.actions;
export default companySkipSaveSlice.reducer;
